module.exports = __webpack_public_path__ + "img/3_61.39ee2209.png";